<template lang="pug">
  a.text-light(:href="url" v-if='!loading')
    slot(name="icon")
      span.cap-icon.text-transparent.text-v-middle(:class='iconClass')
    span.text-underline.text-v-middle
      strong {{ balance | money(currency) }}

</template>

<script lang="ts">
import Vue from 'vue';
// import Component from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { ViewFiltersMixin } from '@/models/filters/view';
import { Balances } from '@/views/layouts/header/header';
import { CurrencyCode, isFiatCurrency } from "@/models/core/currency";

// declare module 'vue/types/vue' {
//     // 3. Объявите расширение для Vue
//     interface Vue {
//         currency: string,
//         iconClass: string
//     }
// }

@Component({
  name: 'balance-amount',
  mixins: [ViewFiltersMixin],
})
export default class BalanceAmount extends Vue {
  @Prop({ required: true })
  balances!: Balances;

  @Prop({ required: true, type: String })
  currency!: CurrencyCode;

  @Prop({ default: '', type: [String, Array, Object] })
  iconClass!: string;

  get url(): string {
      const curType = isFiatCurrency(this.currency) ? 'fiat' : 'crypto';
      return `/finance/accounts/${curType}/${this.currency}`;
  }

  // onBalanceClick() {
  //   this.$emit('balance-click', this.currency);
  // }

  get loading(): boolean {
    return !this.hasValue;
  }

  get hasValue(): boolean {
    return this.balances && this.balances.hasBalanceForCurrency(this.currency);
  }

  get balance(): string {
    return this.hasValue ? `${this.balances.getBalance(this.currency)}` : '0';
  }
}
</script>

<style scoped lang="less">
.capitalist-icon-tether {
  font-size: 12px;
}
.cap-icon {
  margin-right: 0 !important;
}
</style>
